module.exports = __webpack_public_path__ + "img/inter.868f12e0.png";